export const insideMapsPath = "/insidemaps";
export const signInPath = "/signIn";
